import addEventListener from 'utils/DOM/addEventListener'
import buildControllerEmail from 'core/controllers/buildControllerEmail'
import buildControllerPhone from 'core/controllers/buildControllerPhone'
import buildControllerName from 'core/controllers/buildControllerName'
import ifNotTrueExecute from 'utils/ifNotTrueExecute'
import store from 'utils/store/withMiddleware'
import proxyStorage from 'proxy-storage'
import getById from 'utils/DOM/getById'
import { findApplicant } from '@hc-frontend/business'
import buildControllerPhoneExtension from 'core/controllers/buildControllerPhoneExtension'

interface valuesFormProps {
  phoneExt?: string
  email?: string
  message?: string
  fname?: string
  lname?: string
}

function controllerModal(agentInformation, onSubmit) {
  const state = store.getState()
  const hcStorage = state.hcStorage

  const form = getById('send-quote-form-singular')
  const controllers = {
    fname: buildControllerName({ input: form.fname }),
    lname: buildControllerName({ input: form.lname }),
    email: buildControllerEmail({ input: form.email }),
    fullnameAgent: buildControllerName({ input: form.fullname }),
    phone: buildControllerPhone({ input: form.phone, enable800: true }),
    phoneExt: buildControllerPhoneExtension({
      input: form.phoneExt,
      optional: agentInformation.extension ? false : true
    })
  }
  controllers.email.setValue(hcStorage.contact.email_address)
  controllers.fname.setValue(hcStorage.members[0].firstName)
  controllers.lname.setValue(hcStorage.members[0].lastName)
  controllers.fullnameAgent.setValue(agentInformation.full_name)
  controllers.phone.setValue(agentInformation.phone)
  controllers.phoneExt.setValue(agentInformation.extension)

  for (const name in controllers) {
    if (controllers[name].getStatus().value) {
      controllers[name].validate()
    }
  }

  addEventListener(form, 'submit', e => {
    e.preventDefault()
    const valuesForm: valuesFormProps = {}

    let isValidForm = true

    for (const key in controllers) {
      const controller = controllers[key]
      const status = controller.getStatus()
      ifNotTrueExecute(status.valid, controller.validate)
      isValidForm = isValidForm && status.valid
      valuesForm[key] = status.value
    }

    if (isValidForm) {
      valuesForm.message = form.message.value
      valuesForm.phoneExt = form.phoneExt.value

      const hcStorage = proxyStorage.getItem('hc')
      hcStorage.contact.email_address = valuesForm.email
      hcStorage.contact.first_name = valuesForm.fname
      hcStorage.contact.last_name = valuesForm.lname
      const applicant = findApplicant(hcStorage.members)
      applicant.firstName = valuesForm.fname
      applicant.lastName = valuesForm.lname
      proxyStorage.setItem('hc', hcStorage)

      onSubmit(valuesForm)
    }
  })
}

export default controllerModal
